









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Warning } from '@/pages/profile/components';
import MentoringProgramsList from '../../programslist';
import { REQUEST_WARNING } from '@/pages/profile/modules';
import { IMentoringAllPrograms, PopupData, Programs } from './types';

@Component({
  components: {
    Warning,
    MentoringProgramsList,
  },
})
export default class MentoringAllPrograms
  extends Vue
  implements IMentoringAllPrograms {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Programs;

  public warningText: string = REQUEST_WARNING;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/views/allprograms/MentoringAllPrograms.vue